
import {  mapActions } from "vuex";
import Countries from "@/api/country_code";
import { LookingAt, getLookingAtById } from "@/api/looking_at";
import { BusinessModel, getBusinessModelById } from "@/api/business_model";
import { InvestorType, getInvestorTypeById } from "@/api/investor_type";
import {
  InvestmentStage,
  getInvestmentStageById,
} from "@/api/investment_stage";
import { StakeholderType, getStakeholderById } from "@/api/stakeholder_type.js";
import ButtonPrimary from "@/components/Button/ButtonPrimary";

export default {
  name: "FormClaimStartupProfile",
  props: {
    // startupProfile: { type: Object, default: {} },
  },
  components: {
    ButtonPrimary,
  },
  data() {
    return {
      startupProfile: {},
      imageName: "",
      imageUrl: "",
      imageFile: "",
      dialog: false,
      countries: Countries,
      businessModels: BusinessModel,
      employeeRangeList: ["1-10", "11-50", "51-100", "Above 100"],

      lookingAtList: LookingAt,
      investor_type: InvestorType,
      investment_stage: InvestmentStage,
      stakeholder_type: StakeholderType,
    };
  },
  methods: {
    ...mapActions("stakeholder", ["claimRequest"]),
    openForm(profile) {
      this.startupProfile = this.$common.cloneJSON(profile);
      this.imageUrl = this.startupProfile.logo;
      this.dialog = true;
    },
    getLookingAtById(id) {
      return getLookingAtById(id);
    },

    getBusinessModelById(id) {
      return getBusinessModelById(id);
    },

    getInvestorTypeById(id) {
      return getInvestorTypeById(id);
    },
    getInvestmentStageById(id) {
      return getInvestmentStageById(id);
    },

    getStakeholderById(id) {
      return getStakeholderById(id);
    },
    _claimProfile() {
      

      this.$swal
          .fire({
            text: this.$t("ecosystem.startup.detail.claim.question"),
            type: "info",
            showCancelButton: true,
            reverseButtons: true,
            width: 400,
            cancelButtonColor: "#d33",
            cancelButtonText: this.$t("dialog.cancel"),
            confirmButtonText: this.$t("get_listed.form.btn.claim"),
          })
          .then((result) => {
            if (result.value) {
              this.claimRequest({
        type: "startup",
        stakeholder: this.startupProfile.id,
        option: "claim",
      })
        .then((res) => {
          let message = res.message;
          this.$swal.fire({
            type: "success",
            showConfirmButton: false,
            text: this.$t("ecosystem.startup.detail.claim.success"),
            timer: 1000
          });

          this.$emit("saved-update");
          this.closeForm();
        })
        .catch((error) => {
          const message = error.response.data.message || error;
          this.$swal.fire(this.$t("msg.failed"), message, "error");
        });
            }
          });


    
    },

    // UIs
    closeForm() {
      this.dialog = false;
    },
  },
};
